module.exports = __webpack_public_path__ + "static/media/accessory2.57f8fc3b.webp";